/** Cuál material hace de portada: la que el profe marcó o, si no marcó, la primera imagen.
 *  La portada NO cuenta como material de clase (no se lista ni se manda por correo). */
export const coverMaterialId = (s) => {
  if (!s) return null;
  if (s.cover_material_id) return s.cover_material_id;
  const img = (s.materials || []).find((m) => m.type === "image");
  return img ? img.id : null;
};

/** Material de clase: todo menos la portada. */
export const classMaterials = (s) => {
  const cover = coverMaterialId(s);
  return (s?.materials || []).filter((m) => m.id !== cover);
};
